export default __webpack_public_path__ + "static/media/sideLogo.a1f6059d.png";